module.exports = __webpack_public_path__ + "img/eat_feet_blue.178f54af.jpg";